import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { InternalPaymentEffects } from './internal.effects';

@NgModule({
  declarations: [],
  imports: [CommonModule, EffectsModule.forFeature([InternalPaymentEffects])],
})
export class InternalPaymentModule {}
